import { ConfigurationParameters, ResponseContext } from '../_openapi/portfolio-optimizer';

export const defaultApiConfig: ConfigurationParameters = {
    basePath: '/api',
    credentials: 'include',
    headers: {
        'Content-Type': 'application/json',
    },
    middleware: [
        {
            post: async (context: ResponseContext) => {
                /**
                 * the built-in error handing of the generated fetch client is not surfacing
                 * the error message returned by the backend, so we have to throw it manually
                 * of it has an error message, otherwise fall back to the default error
                 */
                if (context.response.status >= 300) {
                    const body = await context.response.json();
                    if (body.message) {
                        throw new Error(body.message);
                    }
                }
                return context.response;
            },
        },
    ],
};
